import { useState } from 'react';

import { getPartyColor } from './party-colors';
import type { IVoteCount } from './utils';

/** The party's logo, or a two-letter fallback in the party's colour when it has none or it fails. */
export const PartyAvatar = ({ vote }: { vote: IVoteCount }) => {
	const [imgError, setImgError] = useState(false);
	const color = getPartyColor(vote.label);

	if (vote.logo && !imgError) {
		return (
			<div className='pv-card__avatar'>
				<img
					src={vote.logo}
					alt={vote.label}
					className='pv-card__logo-img'
					onError={() => setImgError(true)}
				/>
			</div>
		);
	}

	return (
		<div
			className='pv-card__avatar pv-card__logo-fallback'
			style={{ backgroundColor: color.bg, color: color.text }}
		>
			{vote.label.slice(0, 2)}
		</div>
	);
};

export default PartyAvatar;
